import { ModelRequest } from "../lib";

export const Auth = new ModelRequest("auth");
export const User = new ModelRequest("user");
export const Doc = new ModelRequest("docs");
export const DocMeta = new ModelRequest("/doc_meta/:doc_id/");
export const DocUser = new ModelRequest("/doc_users/:doc_id/");
export const Page = new ModelRequest("/pages/:doc_id/");
export const File = new ModelRequest("/files/:doc_id/");
export const PageContents = new ModelRequest("/page_contents/:doc_id/");
export const Books = new ModelRequest("books");
export const Featured = new ModelRequest("featured");
export const Tag = new ModelRequest("tags");
export const Merge = new ModelRequest("/merge/:doc_id/");
export const Translate = new ModelRequest("/translate/:src_lang/:dst_lang/");
export const DocPDF = new ModelRequest("pdf");
export const Resize = new ModelRequest("resize");
